export var initialStatePageKey = 'notificationDrawer';
export var SURVEY_PAGE_KEY = 'notificationDrawer';
export var SURVEY_TRANSLATION_KEY = SURVEY_PAGE_KEY;
export var SOURCE_PAGE = 'Notification Page';
export var NOTIFICATIONS_FETCH = 9;